import map from 'lodash/map';

export default (({ edges }) => map(edges, 'node'));
